import * as React from "react";

const baseClass = "rj-pulse-bet-markets__time-period";

export class TimePeriod extends React.Component<{
    periodFrames: string[]
}, {}> {

    renderPeriods() {
        return this.props.periodFrames.map(
            this.periodFrameDraw, this
        );
    }

    periodFrameDraw(frame) {
        return (
            <span className={`${baseClass}-frame`} key={frame}>
                {frame}
            </span>
        );
    }

    render() {
        return (
            <div className={`${baseClass}`}>
                {this.renderPeriods()}
            </div>
        )
    }
}